import React, { useState } from 'react'

import { Link, useNavigate } from 'react-router-dom'
import logo from '../images/dot-logo.svg'

/**
 * Show this Navbar when user is whitelisted. Does not display Signout button.
 */
function NavbarWhitelisted() {

  const [reportId, setReportId] = useState()
  const navigate = useNavigate()

  const searchHandler = (e) => {
    e.preventDefault()
    const term = e.target.term.value
    navigate(`/search/${term}`)
  }

  return (
    <>
      <nav className="navbar navbar-expand-lg">
        <div className="container-fluid">
          <Link to="/" className="navbar-brand" style={{minWidth: '290px'}}><img src={logo} /></Link>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <Link to="/home/reports" className="nav-link">Reports</Link>
              </li>
              <li className="nav-item">
                <Link to="/home/daily" className="nav-link">Daily Report</Link>
              </li>
            </ul>
            <form onSubmit={searchHandler} className="d-flex" role="search">
              <input className="form-control  form-control-sm me-2" type="search" name="term" placeholder="Search Articles" aria-label="Search" />
              <button className="btn btn-outline-light me-2" type="submit"><i className="fa-solid fa-magnifying-glass"></i></button>
            </form>
          </div>
        </div>
      </nav>
    </>
  )
}

export default NavbarWhitelisted